import { Link } from "react-router-dom";
  

const NavBar = () => (
    <nav className="navbar navbar-light" style={{backgroundColor: 'white', boxShadow: '10px 5px 8px black',}} >
        <Link to="/" className="navbar-brand" >
            <img style={{marginLeft: '20px'}} src="http://austintebbs.com/pogoz.jpg" height="80" alt=""/>
        </Link>
    </nav>
);

export default NavBar;